import { endpoints } from '../api/endpoints'
import { userTypes } from '../constantes/actionTypes'
import { TOKEN_KEY } from '../constantes/localStorageKeys'
import { API } from './comunApi'

export const authApi = {

    login: params => (
        API.post(
            endpoints.AUTHENTICATE,
            params
        )
    ),

    logout: () => { // eliminamos el token del localStorge
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem("persist:root")
        return { type: userTypes.LOGOUT }
    }

}